import { COLORS_FAMILY_KEY } from '@/constants/colors-family-key';
import { appendNofollowMeta, removeNofollowMeta } from '@/util/nofollow-meta';
import { useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

const CategoryNoIndex = props => {
  const { filterState } = props;
  const searchParams = useSearchParams();
  const filterCount = filterState.length;

  useEffect(() => {
    const searchParamKeys = Array.from(searchParams.keys());
    const onlyHasColorFilter = searchParamKeys.every(x => x === 'color' || x === COLORS_FAMILY_KEY);

    if (filterCount > 3 || (searchParamKeys.length !== 0 && !onlyHasColorFilter)) {
      appendNofollowMeta();
    } else {
      removeNofollowMeta();
    }
  }, [filterCount, searchParams]);

  return null;
};

export default CategoryNoIndex;
